export const ERROR_REPORTING_ID_NG = 'next-gen';
export const ERROR_REPORTING_ID_CLASSIC = 'classic';
export const ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwarePeriscope';
